import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { getV1Config, setV1Config } from '@host-panel/request/config';

import { LOADING, NONE } from '../../scripts/models/request-status';

import { addWhitelistedUrl, fetchSuperAdminData, removeWhitelistedUrl, saveHostOptions } from './superAdminActions';
import {
  FetchConfigInjectionsResponse,
  FetchSuperAdminDataPayload,
  SaveConfigPayload,
  WhitelistedUrlsCrudResponse
} from './superAdminTypes';
import { addWhitelistedUrlRequest, fetchWhitelistedUrls, removeWhitelistedUrlRequest } from './superAdminApi';
import { INJECTION_CONFIG_FIELDS } from './superAdminConstants';
import { setHostOptions, setHostOptionsStatus, setInitData, setUrls } from './superAdminSlice';

function* fetchSuperAdminDataSaga(action: PayloadAction<FetchSuperAdminDataPayload>) {
  const { spotId, done } = action.payload;

  try {
    const [whitelistedUrlsResponse, configResponse]: [
      WhitelistedUrlsCrudResponse,
      FetchConfigInjectionsResponse
    ] = yield all([call(fetchWhitelistedUrls), call(getV1Config, spotId, INJECTION_CONFIG_FIELDS)]);

    const { domains } = whitelistedUrlsResponse;
    const { injection } = configResponse;
    const { host_options: hostOptions } = injection;

    yield put(setInitData({ urls: domains, hostOptions }));
  } catch (reason) {
    console.error(reason);
  } finally {
    done();
  }
}

function* addWhitelistedUrlSaga(action: PayloadAction<string>) {
  const url = action.payload;

  try {
    const response: WhitelistedUrlsCrudResponse = yield call(addWhitelistedUrlRequest, url);
    const { domains } = response;

    yield put(setUrls(domains));
  } catch (reason) {
    console.error(reason);
  }
}

function* removeWhitelistedUrlSaga(action: PayloadAction<string>) {
  const url = action.payload;

  try {
    const response: WhitelistedUrlsCrudResponse = yield call(removeWhitelistedUrlRequest, url);
    const { domains } = response;

    yield put(setUrls(domains));
  } catch (reason) {
    console.error(reason);
  }
}

function* saveHostOptionsSaga(action: PayloadAction<SaveConfigPayload>) {
  const { spotId, value } = action.payload;

  yield put(setHostOptionsStatus(LOADING));

  try {
    yield call(setV1Config, spotId, [{ key: 'host_options', value }]);
    yield put(setHostOptions(value));
  } catch (reason) {
    console.error(reason);
  }

  yield put(setHostOptionsStatus(NONE));
}

export function* superAdminSagas() {
  yield takeLatest(fetchSuperAdminData, fetchSuperAdminDataSaga);
  yield takeLatest(addWhitelistedUrl, addWhitelistedUrlSaga);
  yield takeLatest(removeWhitelistedUrl, removeWhitelistedUrlSaga);
  yield takeLatest(saveHostOptions, saveHostOptionsSaga);
}
